import LCAside from "@/components/LCAside";
import LCHearder from "@/components/LCHearder";
export default {
  name: "LCMain",
  components: {
    LCAside,
    LCHearder
  },
  computed: {
    key: function () {
      console.log(this.$router.fullPath);
      return this.$route.fullPath;
    }
  }
  // data(){
  //     return{
  //       // key:this.$router.fullPath
  //     }
  // }
};